export default {
      id: "planification-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#planification-usage",
      toString: function () {
        return this.url;
      }
    }